<cwc-page>


    <!-- Main slot -->
    <div slot="main">
        <div class="btn_idiomas">
            <button [class.active-lang]="activeLang === 'en'" (click)="changeLanguage('en')">{{ 'En' | translate }}</button>|<button
                [class.active-lang]="activeLang === 'es'" (click)="changeLanguage('es')">{{ 'Es' | translate }}</button>
        </div>
        <cwc-grid class="demo-grid">
            <cwc-cell colspan="7" mobile-colspan="12" class="div_imagen_home"></cwc-cell>
            <cwc-cell colspan="5" mobile-colspan="12" class="div_login center_v h_full pading_big ">


                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" id="login__form">

                    <div class="simple-form__form-wrapper cmx-login login__form form_padding">
                        <h2 class="login__form-heading">
                            {{ 'name_app' | translate }}
                        </h2>



                        <div *ngIf="loginError" class="cwc-login__error">{{ loginError }}</div>
                        <div class="simple-form__buttons">

                            <cwc-button design-version="v2" variant="primary" (cwcClick)="onSubmit()">{{ 'login' |
                                translate
                                }}</cwc-button>
                        </div>

                    </div>
                </form>
                <div *ngIf="loading" style="justify-self: center;">
                    <cwc-loader>
                        <span slot='loading'>{{ 'Loading...' | translate }}</span>
                    </cwc-loader>
                </div>

            </cwc-cell>
        </cwc-grid>
    </div>
</cwc-page>
<!-- <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <input formControlName="username" placeholder="username" />
    <input formControlName="password" type="password" placeholder="Password" />
    <button type="submit">Login</button>
</form> -->